import { render, staticRenderFns } from "./openVideoClassAdd.vue?vue&type=template&id=2ed46b12&scoped=true"
import script from "./openVideoClassAdd.vue?vue&type=script&lang=js"
export * from "./openVideoClassAdd.vue?vue&type=script&lang=js"
import style0 from "./openVideoClassAdd.vue?vue&type=style&index=0&id=2ed46b12&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed46b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed46b12')) {
      api.createRecord('2ed46b12', component.options)
    } else {
      api.reload('2ed46b12', component.options)
    }
    module.hot.accept("./openVideoClassAdd.vue?vue&type=template&id=2ed46b12&scoped=true", function () {
      api.rerender('2ed46b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/video/openVideoClassAdd.vue"
export default component.exports